var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tiktok-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m349.1 13.5c0.1 7.4 2.2 114.5 114.9 121.2 0 30.9 0 53.3 0 82.7-8.5 0.5-74.1-4.2-115-40.6l-0.1 161.1c1.6 111.8-80.9 179.9-188.7 156.4-185.8-55.5-124.1-330.6 62.5-301.1 0 88.8 0.1-0.1 0.1 88.8-77.1-11.3-102.9 52.7-82.4 98.5 18.6 41.7 95.4 50.7 122.2-8.1q4.5-17.3 4.5-39.4v-319.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/Tiktok.ad16bc427cc8f21c5627dc31433d59de.svg";
export { ForwardRef as ReactComponent };